// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__Yb9hA","rootSmall":"AddTileButton_rootSmall__239Ml"};